// Public API Service for Landing Page
// No authentication required for these endpoints

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class PublicApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, params = {}) {
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
      )
    ).toString();

    const url = `${this.baseURL}${endpoint}${queryString ? `?${queryString}` : ''}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Public API Request Error:', error);
      throw error;
    }
  }

  async post(endpoint, data) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(data),
      });
      
      const responseData = await response.json();
      
      if (!response.ok) {
        const error = new Error(responseData.message || `HTTP error! status: ${response.status}`);
        error.response = { data: responseData };
        throw error;
      }

      return { data: responseData };
    } catch (error) {
      console.error('Public API POST Error:', error);
      throw error;
    }
  }

  // Generic GET method
  async get(endpoint) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
      
      const responseData = await response.json();
      
      if (!response.ok) {
        const error = new Error(responseData.message || `HTTP error! status: ${response.status}`);
        error.response = { status: response.status, data: responseData };
        throw error;
      }

      return responseData;
    } catch (error) {
      console.error('Public API GET Error:', error);
      throw error;
    }
  }

  // Get all categories with products count for landing page
  async getCategories(region) {
    return this.request('/public/categories', region ? { region } : {});
  }

  // Get products for landing page
  async getProducts(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const endpoint = queryString ? `/public/products?${queryString}` : '/public/products';
    return this.request(endpoint);
  }

  // Get site settings (header, footer, general)
  async getSettings() {
    return this.request('/public/settings');
  }

  // Get storage URL for images
  getImageUrl(imagePath) {
    if (!imagePath) return null;
    const storageBaseUrl = this.baseURL.replace('/api', '');
    // Check if path already starts with /storage/ to avoid double prefix
    if (imagePath.startsWith('/storage/')) {
      return `${storageBaseUrl}${imagePath}`;
    }
    // Check if path starts with storage/ (without leading slash)
    if (imagePath.startsWith('storage/')) {
      return `${storageBaseUrl}/${imagePath}`;
    }
    return `${storageBaseUrl}/storage/${imagePath}`;
  }
}

const publicApi = new PublicApiService();
export default publicApi;
